export default __webpack_public_path__ + "static/media/stereo_03.1656382f.gif";